import { render } from "./ServiceTile.vue?vue&type=template&id=4cc5975a"
import script from "./ServiceTile.vue?vue&type=script&lang=js"
export * from "./ServiceTile.vue?vue&type=script&lang=js"
script.render = render

export default script